<template>
  <div>
    <el-row>
      <h5 style="color: #C0C4CC;">下单商品</h5>
      <el-table :data="selectOrderTableData" row-key="sid" :show-header="false" :row-style="{ color: 'red' }">
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column prop="cgoodsSku" align="center" label="SKU" width="90" />
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w30 h30" :src="scope.row.cmasterUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="商品编码" align="center" width="130" prop="cgoodsBarcode" />
        <el-table-column label="商品名称" align="center" prop="cgoodsName" />
        <el-table-column label="单位" align="center" width="50" />
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            <div>￥ {{ (scope.row.dgoodsPrice / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="ngoodsNum" align="center" width="130" />
      </el-table>
    </el-row>
    <el-row>
      <pickingChangeChoose ref="pickingChangeChoose" :store-id="storeId" @OrderGoodsAdd="handleChooseGiveGoods" />
    </el-row>
    <el-row>
      <h5 style="color: #C0C4CC;">替换货品</h5>
      <el-button style="float: right;" type="primary" size="mini" @click="dialogVisible = true">选取</el-button>
      <el-table :data="replaceTableData" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" :row-style="{ background: '#f5f7fa' }">
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column align="center" label="SKU" width="90">
          <template #default="scope">
            <el-input v-model="scope.row.cremark" maxlength="5" placeholder="SKU" @input="checkSKU(scope.$index, scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w50 h50" :src="scope.row.cmasterUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="货品编码" align="center" width="130" prop="csku" />
        <el-table-column label="货品名称" align="center">
          <template #default="scope">
            <el-tooltip class="item" effect="dark" :disabled="!scope.row.cname" :content="scope.row.cname" placement="top">
              <el-select v-model="scope.row.cname" style="color: red" filterable placeholder="请选择" @change="checkGoodsName(scope.$index, scope.row)">
                <el-option v-for="item in options" :key="item.sid" :label="item.label" :value="item.sid" />
              </el-select>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="单位" align="center" width="50" prop="cunit" />
        <el-table-column label="单价" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.nprice">￥ {{ scope.row.nprice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="库位" align="center" width="70" prop="cwarehouse" />
        <el-table-column label="数量" align="center" width="130">
          <template #default="scope">
            <el-input-number v-if="scope.row.cremark || scope.row.cname" v-model="scope.row.num" controls-position="right" :min="1" :max="999"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="可用库存" align="center" width="60">
          <template slot-scope="scope">
            <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces;">
              {{ scope.row.navailable }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="55">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="red" @click="onDel(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
      <div></div>
      <div>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </div>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="添加商品" :visible.sync="dialogVisible" width="1000px" append-to-body>
      <inventOrderGoodsAdd v-if="dialogVisible" :select-store="{ rstore: storeId }" @handleClose="handleClose" @handleChoose="handleChooseGiveGoods" />
    </el-dialog>
  </div>
</template>

<script>
import inventOrderGoodsAdd from "@/views/order/dialog/inventOrderGoodsAdd.vue";
import pickingChangeChoose from "./pickingChangeChoose/pickingChangeChoose.vue"
export default {
  name: "OrderGoodsAdd",
  components: { inventOrderGoodsAdd, pickingChangeChoose },
  props: {
    selectOrderTableData: {
      type: Array,
      default: () => [],
    },
    storeId: {
      type: String,
      default: () => "",
    }
  },
  data() {
    return {
      replaceTableData: [],
      //商品列表
      options: [],
      selectValue: '',
      dialogVisible: false,
    };
  },
  mounted() {
    let num = 0;
    let barcodes = "";
    for (let i = 0; i < this.selectOrderTableData.length; i++) {
      num += this.selectOrderTableData[i].ngoodsNum;
      if (barcodes.length > 0) {
        barcodes += ",";
      }
      barcodes += this.selectOrderTableData[i].cgoodsBarcode;
    }
    this.$refs.pickingChangeChoose.handleSearch(barcodes, num);
    this.selectByGoodsName();
  },
  methods: {
    handleChooseGiveGoods(goodsList) {
      this.replaceTableData = goodsList;
      this.dialogVisible = false;
    },
    handleGiveGoodsClose() {
      this.dialogVisible = false;
    },
    selectByGoodsName() {
      this.topsAjax.get(`${this.baseUrls.viewInventory}/queryList`, { rstore: this.storeId }).then((res) => {
        this.options = res;
      });
    },
    checkGoodsName(index, row) {
      const filteredItems = this.replaceTableData.filter((item) => item.c_name === row.c_name);
      if (filteredItems.length > 1) {
        this.$message.error("存在重复商品");
        this.selectValue = "";
        return;
      }
      for (let i = 0; i < this.options.length; i++) {
        if (row.sid === this.options[i].sid) {
          this.$set(this.replaceTableData, index, this.options[i]);
        }
      }
      this.options = [];
    },
    checkSKU(index, row) {
      if (row.cremark.length === 5) {
        // 判断是否重复
        let count = 0;
        for (let i = 0; i < this.replaceTableData.length; i++) {
          if (this.replaceTableData[i].cremark.toUpperCase() === row.cremark.toUpperCase()) {
            count++;
          }
        }
        if (count > 1) {
          this.$message.error("存在重复商品");
          row.cremark = "";
          return;
        }
        //回显数据
        this.topsAjax.get(`${this.baseUrls.viewInventory}/getByStoreAndSku`, {rstore: this.storeId, csku: row.cremark}).then((res) => {
          if (res) {
            this.$set(this.replaceTableData, index, res);
          } else {
            this.$message.error("未获取到商品信息");
          }
        });
      }
    },
    handleConfirm() {
      if (this.selectOrderTableData.length > 1 && this.replaceTableData.length > 1) {
        this.$message.error("合并时，只能选取一条数据");
        return;
      }
      let orderIds = '';
      let orderArr = [];
      for (let i = 0; i < this.selectOrderTableData.length; i++) {
        if (orderIds.length > 0) {
          orderIds += ',';
        }
        orderIds += this.selectOrderTableData[i].sid;
        orderArr.push(this.selectOrderTableData[i].sid);
      }
      for (let i = 0; i < this.replaceTableData.length; i++) {
        if (this.replaceTableData[i].sid === undefined) {
          this.$message.error("第:" + (i + 1) + "行，未获取到货品信息");
          return;
        }
        if (this.replaceTableData[i].navailable <= 0) {
          this.$message.error("第:" + (i + 1) + "行，库存不能为空");
          return;
        }
        this.replaceTableData[i].rplatformOrderDetail = orderIds;
      }
      this.$emit("handleSubmit", this.replaceTableData, orderArr);
    },
    handleClose() {
      this.$emit("handleClose");
    },
    onDel(index) {
      this.replaceTableData.splice(index, 1)
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none !important;
  box-shadow: none !important;
}
.newOrderGoodsAdd {
  height: 600px;
  background-color: white;
  display: flex;
  flex-direction: column;



  .el-tabs__item {
    padding: 0 10px;
  }

  .el-tabs__item.is-active {
    text-decoration: underline;
  }


  .el-popper[x-placement^="bottom"] {
    margin-left: -40px;
  }
}

//.orderGoodsAdd {
//  height: 500px;
//  background-color: white;
//  display: flex;
//  flex-direction: column;
//
//  &__top {
//    flex: 1;
//  }
//
//  &__bottom {
//    height: 50px;
//    line-height: 50px;
//    text-align: right;
//  }
//
//  .el-input {
//    width: 120px;
//  }
//
//  .cell {
//    & > div {
//      width: 120px;
//    }
//  }
//}
</style>
